import { FullModal } from "./fullModal";
import {
  Cheveron,
  FilledSuccessCheck,
  Locate,
} from "../../../../components/svg/worldSvgs/rmc/Achievements";
import { RMCCard } from "../../../../components/world/rmc/card";
import { IconOverlay } from "../../../../components/world/rmc/IconOverlay";
import Button from "../../../../components/world/rmc/Button";
import { TransactionBadge } from "../../../../components/world/rmc/TransactionBadge";
import dayjs from "dayjs";
import { formatToNaira } from "../../../../utils";

export const SuccessModal = ({ action, transaction, handleDone }) => {
  return (
    <FullModal>
      <div className="px-4 pt-16 relative">
        <div className="flex flex-col items-center justify-center mb-5">
          <FilledSuccessCheck />
          <p className="text-2xl text-white font-semibold">{`${action} Successful!`}</p>
        </div>
        <RMCCard className="my-12 flex flex-col gap-5">
          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#FFFFFFBF]">
              References Number
            </span>
            <span className="text-xs font-normal text-[#FFFF]">
              {transaction?.payment_reference ?? "Reference not available"}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#FFFFFFBF]">
              Transaction Status
            </span>
            <TransactionBadge status={transaction?.status} />
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#FFFFFFBF]">
              Transaction Time
            </span>
            <span className="text-xs font-normal text-[#FFFF]">
              {transaction?.created_at
                ? dayjs(transaction.created_at).format("DD-MM-YYYY, HH:mm:ss")
                : "N/A"}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#FFFFFFBF]">
              Payment Method
            </span>
            <span className="text-xs font-normal text-[#FFFF]">
              {transaction?.payment_method}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-xs font-normal text-[#FFFFFFBF]">
              Credited to
            </span>
            <span className="text-xs font-normal text-[#FFFF]">Wallet</span>
          </div>

          {transaction?.amount && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#FFFFFFBF]">
                Amount
              </span>
              <span className="text-xs font-normal text-[#FFFF]">
                {formatToNaira(transaction?.amount ?? 0)}
              </span>
            </div>
          )}

          {transaction?.recipientMobile && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#FFFFFFBF]">
                Recipient Mobile
              </span>
              <span className="text-xs font-normal text-[#FFFF]">
                {transaction.recipientMobile}
              </span>
            </div>
          )}

          {transaction?.transactionType && (
            <div className="flex justify-between">
              <span className="text-xs font-normal text-[#FFFFFFBF]">
                Transaction Type
              </span>
              <span className="text-xs font-normal text-[#FFFF]">
                {transaction?.transactionType}
              </span>
            </div>
          )}
        </RMCCard>

        <RMCCard className="flex items-center justify-between gap-3 !py-2.5 !pl-2.5 !pr-7 cursor-pointer mb-5">
          <div className="flex items-center gap-2.5">
            <IconOverlay>
              <Locate />
            </IconOverlay>

            <div>
              <p className="text-base font-semibold text-white mb-1">
                Trouble with your redeeming?
              </p>
              <p className="text-xs font-medium text-[#FFFFFF80] leading-tight">
                Let us know on help center now!
              </p>
            </div>
          </div>

          <Cheveron stroke="#FFFFFF80" />
        </RMCCard>
        <Button
          onClick={handleDone}
          text="Done"
          className="!py-[18px] !text-lg !font-semibold "
        />
      </div>
    </FullModal>
  );
};
